import { useMemo } from 'react';
import { createFilterConditionFactory, createNotNullOrEmptyFilterCondition } from '@deephaven/jsapi-utils';
import useTableUtils from "./useTableUtils.js";
export function useNotNullOrEmptyFilter(columnNames) {
  var conditionOperator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  var tableUtils = useTableUtils();
  var notNullOrEmptyFilterCondition = useMemo(() => createNotNullOrEmptyFilterCondition(tableUtils), [tableUtils]);
  return useMemo(() => createFilterConditionFactory(columnNames, notNullOrEmptyFilterCondition, conditionOperator), [columnNames, conditionOperator, notNullOrEmptyFilterCondition]);
}
export default useNotNullOrEmptyFilter;
//# sourceMappingURL=useNotNullOrEmptyFilter.js.map